<template>
	<div class="flying-button-wrapper">
		<div class="flying-inside">
			<div class="flying-button btn-add-outlet" @click="add"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOFABRegular",
	methods: {
		add(payload) {
			this.$emit("add", payload)
		}
	}
}
</script>